
<template>
  <div class="captcha"></div>
</template>

<script>
export default {
  name: "AliCaptcha",
  props: ["captchaConfig"],
  mounted() {
    window.initAlicom4(
      this.captchaConfig.config,
      this.captchaConfig.handler
    );
  },
};
</script>
